import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import ErrorModal from './ErrorModal';

const batchURI= process.env.REACT_APP_API_BATCH_URL;

const BoardEmployee = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [employees, setEmployees] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [customer, setCustomer] = useState([]);
  
  const [errors, setErrors] = useState({}); // Error state

  const [apierrors, setApiErrors] = useState('');// Error state
  
  const [filterTerm, setFilterTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Bitte warten …');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page


  
  //const [customers, setCustomers] = useState([]);
  
  const [formData, setFormData] = useState({
    employees_firstname: '',
    employees_lastname: '',
    employees_email: '',
    employees_mobile: '',
    belongs_to_costumer_id: '',
    rec_date: '',
    t_customer: { customer_id: 0, custumer_company_name: "" },
    //t_sub_vo: { sub_vo_id: 0 }
   });
  
   
  useEffect(() => {
    
    console.log("Hallo World Tolrd"+ currentUser.roles[0]);
    const user = JSON.parse(localStorage.getItem('user'));

    

    // Extract extId if available
    const extId = user ? user.extid : null;

    console.log("Hallo World Customer"+customer);
    console.log("Hallo World Customer"+extId);
    
      // If extId is null, call getEmployeesBoard()
      UserService.getEmployiesBoard().then(
        (response) => {
          console.log("Hallo World"+response);
          setEmployees(response.data);
          
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
            setEmployees(_content);
  
          if (error.response && error.response.status === 401) {
            EventBus.dispatch("logout");
          }
        }
      );

      UserService.getCustomerBoard().then(
        (response) => {
          if (Array.isArray(response.data)) {
            setCustomer(response.data);
          } else {
            console.error("API response is not an array:", response.data);
            setCustomer([]);
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
            if (error.response) {
              // Server responded with a status other than 200 range
              setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
              setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
            } else if (error.request) {
              // Request was made, but no response was received
              setApiErrors('Keine Antwort vom Server.');
              setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
            } else {
              // Other types of errors
              setApiErrors(`Fehler: ${error.response.data.message}`);
              setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
            } 
          setCustomer(_content);
  
          if (error.response && error.response.status === 401) {
            EventBus.dispatch("logout");
          }
        }
      );
    
    
  
  }, [deleteState]);

  useEffect(() => {
    validateForm();
  }, [formData]); // This will run every time formData is updated

  // Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(employees)
? employees.filter((vo) =>
    (vo.employees_firstname && vo.employees_firstname.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.employees_lastname && vo.employees_lastname.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.employees_email && vo.employees_email.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo.employees_mobile && vo.employees_mobile.includes(filterTerm)) ||
    //(vo?.t_sub_vo?.company_name && vo.t_sub_vo.company_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
    (vo?.t_customer?.customer_company_name && vo.t_customer.customer_company_name.toLowerCase().includes(filterTerm.toLowerCase())) || 
    (vo.rec_date && vo.rec_date.includes(filterTerm))
  )
: [];



// Get the current page's data
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);

// Handle pagination
const handlePageChange = (pageNumber) => {
setCurrentPage(pageNumber);
};

// Sorting function
const handleSort = (key) => {
let direction = 'asc';
if (sortConfig.key === key && sortConfig.direction === 'asc') {
direction = 'desc';
}
setSortConfig({ key, direction });
};



const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
let aValue, bValue;

// Handle nested properties for sorting
/*if (sortConfig.key === 't_sub_vo.company_name') {
aValue = a.t_sub_vo?.company_name || '';
bValue = b.t_sub_vo?.company_name || '';
} */ 
if (sortConfig.key === 't_customer.custumer_company_name') {
  aValue = a.t_customer?.custumer_company_name || '';
  bValue = b.t_customer?.custumer_company_name || '';
} 
else {
// For non-nested keys
aValue = a[sortConfig.key];
bValue = b[sortConfig.key];
}

// Perform the comparison based on direction
if (aValue < bValue) {
return sortConfig.direction === 'asc' ? -1 : 1;
}
if (aValue > bValue) {
return sortConfig.direction === 'asc' ? 1 : -1;
}
return 0;
});


// Total pages calculation
const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);


  // Validate form fields
  const validateForm = () => {
    const newErrors = {};
    console.info('Validate Form:', formData);
    if(currentUser.roles.includes("ROLE_ADMIN") )
    {
    if (!formData.t_customer.customer_id || isNaN(formData.t_customer.customer_id) ) {  
      newErrors.customer_id = 'Bitte einen Kunden auswählen.';
    }
    
      if (parseInt(formData.t_customer.customer_id) <= 0) {
      console.log("customerid Validation"+formData.t_customer.customer_id);
      newErrors.customer_id = 'Die Kundennummer muss größer als 0 sein.';
    }
   }
    /*if (!formData.t_sub_vo.sub_vo_id || isNaN(formData.t_sub_vo.sub_vo_id) ) {  
      newErrors.sub_vo_id = 'Bitte einen Vertriebspartner auswählen.';
    }
    if (parseInt(formData.t_sub_vo.sub_vo_id) <= 0) {
      console.log("subvoid Validation"+formData.t_sub_vo.sub_vo_id);
      newErrors.sub_vo_id = 'Die Nummer des Vertriebspartners muss größer als 0 sein.';
    }*/
    if (!formData.employees_firstname.trim()) {
      newErrors.employees_firstname = 'Vorname ist erforderlich';
    }
    if (!formData.employees_lastname.trim()) {
      newErrors.employees_lastname = 'Nachname ist erforderlich';
    }
    if (!formData.employees_email.trim() || !/\S+@\S+\.\S+/.test(formData.employees_email)) {
      newErrors.employees_email = 'Eine gültige E-Mail-Adresse ist erforderlich';
    }
    if (!formData.employees_mobile.trim()) {
      newErrors.employees_mobile = 'Mobilnummer ist erforderlich';
    }else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.employees_mobile)) {
      newErrors.employees_mobile = 'Bitte eine gültige Mobilnummer eingeben';
    }
  
   
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      employees_firstname: '',
      employees_lastname: '',
      employees_email: '',
      employees_mobile: '',
      belongs_to_costumer_id: '',
      rec_date: '',
      t_customer: { customer_id: 0, custumer_company_name: '' },
      //t_sub_vo: { sub_vo_id: 0 }
    });
    setShowCreateModal(true);
  };


  const handleEditClick = (employee) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedEmployee(employee);
    setFormData(employee);
    setShowEditModal(true);
  };

  

  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText(' Der Mitarbeiter wird gelöscht, bitte warten …');
      setLoading(true);
      await UserService.deleteEmployiesBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Fehler: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Employee:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText(' Die Daten werden gespeichert, bitte warten …');
      setLoading(true);
      //formData.rec_date = new Date();
      await UserService.updateEmployiesBoard(selectedEmployee.employee_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      console.error('Error updating Employee:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText(' Die Daten werden gespeichert, bitte warten …');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createEmployiesBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      console.error('Error creating Employee:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
  const name = e.target.name;
  const value = e.target.value;
  console.log("Select Name:"+e.target.name);
  console.log("Select Value before :"+value);
 
  /*if (name === "sub_vo_id") {
    
    setFormData((prevState) => ({
      ...prevState,
      t_sub_vo: {
        ...prevState.t_sub_vo,  // Keep the rest of t_customer intact
        sub_vo_id: value,      // Update only the customer_id
      },
    }));
  }*/
  // Handle nested userRoles role.id update
  if (name === "customer_id") {
    
    

    setFormData((prevState) => ({
      ...prevState,
      t_customer: {
        ...prevState.t_customer,  // Keep the rest of t_customer intact
        customer_id: value,      // Update only the customer_id
      },
    }));
    

    console.log("Select Value after:"+formData.t_customer.customer_id);
  } else {
    // Handle all other input updates
    setFormData({
      ...formData,
      [name]: value,
    });
    
    
  }
  if (!validateForm()) return; 
  console.log("Updated formData:", formData);
};

 

 const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Mitarbeiter</h1>
       {/* Display error if it exists */}
       <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />    
      <Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Mitarbeiter anlegen
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only"> Wird geladen …</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Name, Nummer oder Datum"
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('employee_id')} style={{ cursor: 'pointer' }}>
            Mitarbeiternummer {sortConfig.key === 'employee_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('employees_firstname')} style={{ cursor: 'pointer' }}>
            Vorname {sortConfig.key === 'employees_firstname' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('employees_lastname')} style={{ cursor: 'pointer' }}>
            Nachname {sortConfig.key === 'employees_lastname' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('employees_email')} style={{ cursor: 'pointer' }}>
            E-Mail {sortConfig.key === 'employees_email' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('employees_mobile')} style={{ cursor: 'pointer' }}>
            Mobil {sortConfig.key === 'employees_mobile' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('t_customer.custumer_company_name')} style={{ cursor: 'pointer' }}>
            Kunde {sortConfig.key === 't_customer.custumer_company_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            {/* <th onClick={() => handleSort('t_sub_vo.company_name')} style={{ cursor: 'pointer' }}>
            Customer {sortConfig.key === 't_sub_vo.company_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>*/}
            <th onClick={() => handleSort('qrCode')} style={{ cursor: 'pointer' }}>
            QR-Code {sortConfig.key === 'qrCode' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
           
            <th onClick={() => handleSort('rec_date')} style={{ cursor: 'pointer' }}>
            Anlagedatum {sortConfig.key === 'rec_date' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
           <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
        {sortedMainVOs.map((employee) => (
            <tr key={employee.employee_id}>
              <td>{employee.employee_id}</td>
              <td>{employee.employees_firstname}</td>
              <td>{employee.employees_lastname}</td>
              <td>{employee.employees_email}</td>
              <td>{employee.employees_mobile}</td>
              {/*<td>{employee.t_sub_vo.company_name}</td>*/}
              <td>{employee.t_customer.custumer_company_name}</td>
              <td>
                {/* Check if qrCode exists and render as image */}
                {employee.qrCode ? (
  <a href={`${batchURI}${employee.fetch_url_hash}`} target="_blank" rel="noopener">
    <img
      src={`data:image/png;base64,${employee.qrCode}`}
      alt="QR-Code"
      style={{ width: '100px', height: '100px' }}
    />
  </a>
) : (
  'Kein QR-Code vorhanden'
)}

              </td>
              <td style={{ whiteSpace: 'nowrap' }}>{employee.rec_date}</td>
              <td>
              <ButtonGroup>
                <Button variant="warning" onClick={() => handleEditClick(employee)} className="mr-2">
                  Bearbeiten
                </Button>
                <Button variant="danger" onClick={(e) => handleDeleteClick(employee.employee_id,e)}>
                  Löschen
                </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Erste</Pagination.First>
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Zurück</Pagination.Prev>

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Weiter</Pagination.Next>
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Letzte</Pagination.Last>
      </Pagination>
      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Neuen Mitarbeiter anlegen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formEmployeesFirstname">
              <Form.Label>Vorname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Vorname eingeben"
                name="employees_firstname"
                value={formData.employees_firstname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_firstname} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_firstname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmployeesLastname">
              <Form.Label>Nachname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nachname eingeben"
                name="employees_lastname"
                value={formData.employees_lastname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_lastname} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_lastname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmployeesEmail">
              <Form.Label>E-Mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-Mail eingeben"
                name="employees_email"
                value={formData.employees_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_email} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmployeesMobile">
              <Form.Label>Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mobilnummer eingeben"
                name="employees_mobile"
                value={formData.employees_mobile}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_mobile} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_mobile}
              </Form.Control.Feedback>
            </Form.Group>
       {/*
      <Form.Group controlId="formSubVo">
        <Form.Label>Vertriebspartner</Form.Label>
        <Form.Control
          as="select"
          name="sub_vo_id"
          value={formData.t_sub_vo.sub_vo_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.sub_vo_id}
        >
          <option value="">Vertriebspartner wählen</option>
          {subVos.map(subVo => (
            <option key={subVo.sub_vo_id} value={subVo.sub_vo_id}>
              {subVo.company_name}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.sub_vo_id}
              </Form.Control.Feedback>
      </Form.Group>*/}

      {currentUser.roles.includes("ROLE_ADMIN") && (
      <Form.Group controlId="formSubVo">
        <Form.Label>Kunde</Form.Label>
        <Form.Control
          as="select"
          name="customer_id"
          value={formData.t_customer.customer_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.customer_id}
        >
          <option value="">Kunde wählen</option>
          {customer.map(cus => (
            <option key={cus.customer_id} value={cus.customer_id}>
              {cus.custumer_company_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.customer_id}
              </Form.Control.Feedback>
              
      </Form.Group>
      )}
            

            <Form.Group controlId="formRecDate">
              <Form.Label>Datum</Form.Label>
              <Form.Control
                type="date"
                name="rec_date"
                value={formData.rec_date}
                onChange={handleChange}
              />
            </Form.Group>

            <Button style={{ marginTop: '20px' }} variant="primary" type="submit"  disabled={loading}>
             {loading ? 'Wird gespeichert …' : 'Mitarbeiter speichern'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Mitarbeiter bearbeiten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
          <Form.Group controlId="formEmployeesFirstname">
              <Form.Label>Vorname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Vorname eingeben"
                name="employees_firstname"
                value={formData.employees_firstname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_firstname} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_firstname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmployeesLastname">
              <Form.Label>Nachname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nachname eingeben"
                name="employees_lastname"
                value={formData.employees_lastname}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_lastname} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_lastname}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmployeesEmail">
              <Form.Label>E-Mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-Mail eingeben"
                name="employees_email"
                value={formData.employees_email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_email} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmployeesMobile">
              <Form.Label>Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mobilnummer eingeben"
                name="employees_mobile"
                value={formData.employees_mobile}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.employees_mobile} 
              />
              <Form.Control.Feedback type="invalid">
                {errors.employees_mobile}
              </Form.Control.Feedback>
            </Form.Group>
       {/*
      <Form.Group controlId="formSubVo">
        <Form.Label>Vertriebspartner</Form.Label>
        <Form.Control
          as="select"
          name="sub_vo_id"
          value={formData.t_sub_vo.sub_vo_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.sub_vo_id}
        >
          <option value="">Vertriebspartner wählen</option>
          {subVos.map(subVo => (
            <option key={subVo.sub_vo_id} value={subVo.sub_vo_id}>
              {subVo.company_name}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.sub_vo_id}
              </Form.Control.Feedback>
      </Form.Group>*/}

     {currentUser.roles.includes("ROLE_ADMIN") && (
      <Form.Group controlId="formSubVo">
        <Form.Label>Kunde</Form.Label>
        <Form.Control
          as="select"
          name="customer_id"
          value={formData.t_customer.customer_id}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.customer_id}
        >
          <option value="">Kunde wählen</option>
          {customer.map(cus => (
            <option key={cus.customer_id} value={cus.customer_id}>
              {cus.custumer_company_name}
            </option>
          ))}
          </Form.Control>
        <Form.Control.Feedback type="invalid">
                {errors.customer_id}
              </Form.Control.Feedback>
              
      </Form.Group>
      )}
           

            <Form.Group controlId="formRecDate">
              <Form.Label>Datum</Form.Label>
              <Form.Control
                type="date"
                name="rec_date"
                value={formData.rec_date}
                onChange={handleChange}
              />
            </Form.Group>

            <Button style={{ marginTop: '20px' }} variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Wird gespeichert …' : 'Änderungen speichern'}
            </Button>
            
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardEmployee;
